export default "__VITE_ASSET__CMNEvfK9__"